import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Modal from 'kepler/lib/components/Modal';
import ModalBody from 'kepler/lib/components/ModalBody';
import { locationUpdate } from '../actions/action-contact-location';
import LogIn from '../components/LogIn';
import { closeModalContainer } from '../actions/action-login-modal';
import { dispatchLogin } from '../actions/action-login-redirect';
import { trackLink } from '../../lib/analytics-helper';
import i18n from '../../lib/reacti18n';

class ModalContainer extends Component {

  showLoginPage() {
    const currentUri = window.location.href;
    trackLink({ id: 'intermediatePage', link: `smarthelp-intermediate|login|${this.props.channel}` });
    return this.props.dispatchLogin(currentUri, this.props.channel);
  }
  showGuestPage() {
    trackLink({ id: 'intermediatePage', link: `smarthelp-intermediate|guest|${this.props.channel}` });
    return this.props.locationUpdate({ pageName: 'callUs' });
  }
  render() {
    return (
      <div>
        <Modal
          isOpen={this.props.isModalOpen} type="dialog" width="medium"
          onCancel={() => this.props.closeModalContainer()}
        >
          <ModalBody>
            <LogIn
              content={this.props.content}
              channelType={this.props.channel}
              clickAction={() => this.showLoginPage()}
              linkAction={() => this.showGuestPage()}
            />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  // emailUs--> Intent selected and email--> No intent selected
  const channels = {
    email: 'emailUs',
    callUs: 'callUs',
    emailUs: 'emailUs',
  };
  return {
    content: i18n.message(`smarthelp/${channels[state.modal.channel]}`),
    isModalOpen: state.modal.isModalOpen,
    channel: state.modal.channel,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ closeModalContainer, dispatchLogin, locationUpdate }, dispatch);
}

ModalContainer.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  locationUpdate: PropTypes.func.isRequired,
  dispatchLogin: PropTypes.func.isRequired,
  closeModalContainer: PropTypes.func.isRequired,
  content: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  channel: PropTypes.string.isRequired,
};

ModalContainer.defaultProps = {
  content: {
    login: {
      guestMessage: '',
      header: '',
      instruction: '',
      login: '',
      loginMessage: '',
      message: '',
      trouble: '',
    },
  },
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalContainer);
